var publish = true;
export default {
    API_URL: publish ? "http://antriansukodono.sidoarjokab.go.id:2004" : "http://localhost:2004",
    WS_URL: publish ? "ws://antriansukodono.sidoarjokab.go.id:2004/ws" : "ws://localhost:2004/ws",
    AUTHKEY: "d1b1b720267e8fe3e97bb4f860c2d2d1"
}